export const getWebImageUrl = path => `${process.env.PUBLIC_URL}/${path}`;
